import type { PushNotification } from './PushNotificationBanner';

interface PushNotificationPreviewProps {
  title: string;
  message: string;
  timestamp?: Date;
  appIcon?: string;
}

export function PushNotificationPreview({
  title,
  message,
  timestamp = new Date(),
  appIcon = '📷',
}: PushNotificationPreviewProps) {
  const formattedTime = timestamp.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="bg-[#F4F4F4] dark:bg-[#2C2C2C] rounded-[10px] shadow-sm p-4 max-w-[380px]">
      <div className="flex items-start gap-3">
        <div className="text-[24px]">{appIcon}</div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3 className="text-[13px] text-[var(--color-black)]">pixcapture.app</h3>
            <span className="text-[12px] text-[var(--color-grey)]">{formattedTime}</span>
          </div>
          <p className="text-[13px] text-[var(--color-black)] mb-1">{title}</p>
          <p className="text-[13px] text-[var(--color-grey)]">{message}</p>
        </div>
      </div>
    </div>
  );
}
